import { createFileRoute } from '@tanstack/react-router'
import { useLayoutEffect } from 'react'
import { PlaygroundRouteScreen } from '~/boggle/ui/screens/PlaygroundRouteScreen'
import { useBoggleModeSession } from '~/boggle/ui/state/ModeSession'

export const Route = createFileRoute('/dev/playground')({
  head: () => ({
    meta: [
      { title: 'Playground — Patter' },
      { name: 'robots', content: 'noindex, nofollow' },
    ],
  }),
  component: DevPlaygroundRoute,
})

function DevPlaygroundRoute() {
  const navigate = Route.useNavigate()
  const { clearRouteHostedGameMode } = useBoggleModeSession()

  useLayoutEffect(() => {
    clearRouteHostedGameMode()
  }, [clearRouteHostedGameMode])

  return (
    <PlaygroundRouteScreen
      onExit={() => {
        void navigate({ to: '/' })
      }}
    />
  )
}
